<div id="div1">
  <h1>Test Page</h1>

  <app-phone-call-button></app-phone-call-button>

  <button nz-button nzType="default" nzSize="small" (click)="fixBug()">Get Message list</button>

  <button nz-button nzType="default" nzSize="small" (click)="sendSlackMessage()">Send Slack Message</button>

  <button nz-button nzType="default" nzSize="small" (click)="onRealtimeClientClick()">Realtime API</button>

  <button nz-button nzType="default" nzSize="small" (click)="onSendWeeklyReportClick()">Send Weekly Report</button>

  <button nz-button nzType="default" nzSize="small" (click)="onS3SignedUrlClick()">
    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">arrow_outward</span>
    Get S3 Signed URL
  </button>

  <input type="file" id="fileInput" (change)="onChange()" />
  <div>
    <nz-upload
      nzType="drag"
      [nzMultiple]="true"
      [nzCustomRequest]="uploadFileHandler"
      (nzChange)="handleChange($event)"
      [nzAccept]="['.pdf', '.png']"
    >
      <p class="ant-upload-drag-icon">
        <i nz-icon nzType="inbox"></i>
      </p>
      <p class="ant-upload-text">Click or drag a file to this area to upload</p>
      <p class="ant-upload-hint">Please Upload Only One File under 5MB.</p>
    </nz-upload>
  </div>

  <button (click)="onTestChromeExtension()">Test Chrome Extension</button>
</div>
